import React from 'react';
import { PortalLayout } from './PortalLayout';
import { TrustManagement } from './TrustManagement';

export const TrustPage = ({ role = 'driver' }) => {
  return (
    <PortalLayout role={role}>
      <div className="space-y-6">
        {/* Header */}
        <div>
          <h1 className="text-2xl font-heading font-bold text-white">Trust Management</h1>
          <p className="text-slate-400">
            Configure auto-approval rules for trusted partners
          </p>
        </div>

        {/* Trust Management Component */}
        <TrustManagement />

        {/* Info Card */}
        <div className="glass-card p-6 border-neon-cyan/20">
          <h3 className="text-lg font-semibold text-white mb-3">How Trust Relationships Work</h3>
          <div className="space-y-4 text-sm text-slate-400">
            <div className="flex items-start space-x-3">
              <div className="w-6 h-6 rounded-full bg-neon-green/20 text-neon-green flex items-center justify-center text-xs font-bold flex-shrink-0">1</div>
              <p>When you add a trusted partner, their credential requests can be automatically approved without manual review.</p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="w-6 h-6 rounded-full bg-neon-green/20 text-neon-green flex items-center justify-center text-xs font-bold flex-shrink-0">2</div>
              <p>You can choose to auto-approve all credentials or only specific types (e.g., only background checks and drug screens).</p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="w-6 h-6 rounded-full bg-neon-green/20 text-neon-green flex items-center justify-center text-xs font-bold flex-shrink-0">3</div>
              <p>Set monthly limits and expiration dates to maintain control over your data sharing.</p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="w-6 h-6 rounded-full bg-neon-green/20 text-neon-green flex items-center justify-center text-xs font-bold flex-shrink-0">4</div>
              <p>You can revoke trust at any time, immediately stopping auto-approval for that partner.</p>
            </div>
          </div>
        </div>
      </div>
    </PortalLayout>
  );
};

// Role-specific pages
export const DriverTrustPage = () => <TrustPage role="driver" />;
export const ProviderTrustPage = () => <TrustPage role="provider" />;
export const BrokerTrustPage = () => <TrustPage role="broker" />;

export default TrustPage;
